function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { find as t, findOne as e, on as o } from "domassist";
import i from "attrobj";
import n from "aug";

function s(t) {
  return t.parentNode ? JSON.parse(JSON.stringify(t.parentNode.dataset)).module ? t.parentNode : s(t.parentNode) : t;
}

var r = {
  find: t,
  findOne: e,
  on: o
},
    d = function () {
  function t(e, o) {
    return void 0 === o && (o = ""), this.log("begin setup"), this.el = e, this.els = {}, this.options = n({}, this.defaults, i("module", this.el)), this.moduleName = o || this.el.dataset.module, this.setUps = {
      actions: [],
      named: [],
      options: []
    }, this.boundActionRouter = this.actionRouter.bind(this), this.preInit(), this.storeRef(), this.setupActions(), this.setupNamed(), this.verifyRequired(), this.postInit(), this.log("initalized"), t.debug && (this.el.module = this), this;
  }

  var e,
      o = t.prototype;
  return o.preInit = function () {}, o.postInit = function () {}, o.verifyRequired = function () {
    var t = this;
    return this.required === {} || (void 0 !== this.required.options && (this.setUps.options = Object.keys(this.options)), Object.keys(this.required).forEach(function (e) {
      t.required[e].forEach(function (o) {
        if (t.setUps[e].indexOf(o) < 0) throw new Error(o + " is required as " + e + " for " + t.moduleName + ", but is missing!");
      });
    })), this;
  }, o.setupActions = function () {
    var t = this;
    this.setupAction(this.el), this.find("[data-action]").forEach(function (e) {
      s(e) === t.el && t.setupAction(e);
    });
  }, o.setupAction = function (e) {
    if ("true" !== e.dataset.domoduleActionProcessed) {
      var o = t.parseAction(e),
          i = o.name,
          n = o.type;
      i && ("function" == typeof this[i] ? (this.log(i + " bound"), this.storeSetUp(i, "actions"), r.on(e, n, this.boundActionRouter), e.dataset.domoduleActionProcessed = "true") : this.log(i + " was registered, but there is no function set up"));
    }
  }, o.actionRouter = function (e) {
    var o = e.currentTarget,
        n = t.parseAction(o).name,
        s = i("action", o);
    this[n].call(this, o, e, s);
  }, o.setupNamed = function () {
    var t = this;
    this.find("[data-name]").forEach(function (e) {
      s(e) === t.el && (e.dataset.domoduleNameProcessed || (t.els[e.dataset.name] = e, t.storeSetUp(e.dataset.name, "named"), e.dataset.domoduleNameProcessed = "true", e.dataset.domoduleOwner = t.id));
    });
  }, o.storeRef = function () {
    if (void 0 === window.domorefs && (window.domorefs = {}), void 0 !== window.domorefs[this.el.dataset.moduleUid]) return !1;
    this.id = this.uuid, this.el.dataset.moduleUid = this.id, window.domorefs[this.el.dataset.moduleUid] = this;
  }, o.find = function (t) {
    return r.find(t, this.el);
  }, o.findOne = function (t) {
    return r.findOne(t, this.el);
  }, o.findByName = function (t) {
    return this.els[t];
  }, o.getOption = function (t) {
    return this.options[t];
  }, o.storeSetUp = function (t, e) {
    this.setUps[e].indexOf(t) < 0 && this.setUps[e].push(t);
  }, o.destroy = function () {
    var e = this;
    r.find("[data-action]", this.el.parentNode).forEach(function (o) {
      if ("true" === o.dataset.domoduleActionProcessed) {
        var i = t.parseAction(o);
        o.removeEventListener(i.type, e.boundActionRouter), o.dataset.domoduleActionProcessed = "false";
      }
    });
  }, t.parseAction = function (t) {
    var e = t.dataset,
        o = e.actionType;
    return {
      name: e.action,
      type: void 0 === o ? "click" : o
    };
  }, t.getInstance = function (t) {
    if (t instanceof Node) return window.domorefs[t.dataset.moduleUid];
    throw new Error("getInstance expects a dom node");
  }, t.register = function (e, o) {
    "function" == typeof e && (e = (o = e).prototype.constructor.name), window.domodules || (window.domodules = {}), t.log("Registering " + e), window.domodules[e] = o;
  }, t.discover = function (e) {
    if (void 0 === e && (e = "body"), t.log("Discovering modules..."), window.domodules) {
      var o;
      o = e instanceof Node ? [e] : Array.isArray(e) ? e : r.find(e);
      var i = [];
      return o.forEach(function (e) {
        r.find("[data-module]", e).forEach(function (e) {
          var o = e.dataset.module;

          if (o && "function" == typeof window.domodules[o]) {
            if ("object" == _typeof(window.domorefs) && void 0 !== window.domorefs[e.dataset.moduleUid]) return;
            t.log(o + " found"), i.push(new window.domodules[o](e));
          }
        });
      }), i;
    }

    t.log("No modules found");
  }, o.log = function (e) {
    t.log(this.constructor.name + ": " + e);
  }, t.log = function (e) {
    t.debug && console.log("[DOMODULE] " + e);
  }, (e = [{
    key: "required",
    get: function get() {
      return {};
    }
  }, {
    key: "defaults",
    get: function get() {
      return {};
    }
  }, {
    key: "uuid",
    get: function get() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
        var e = 16 * Math.random() | 0;
        return ("x" === t ? e : 3 & e | 8).toString(16);
      });
    }
  }]) && function (t, e) {
    for (var o = 0; o < e.length; o++) {
      var i = e[o];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }(t.prototype, e), t;
}();

d.debug = "object" == _typeof(window.localStorage) && window.localStorage.getItem("DomoduleDebug"), d.autoDiscover = !0, window.addEventListener("DOMContentLoaded", function () {
  d.autoDiscover && d.discover();
});
export default d;